import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=3bf68e80&scoped=true"
import script from "./AuditLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditLog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=3bf68e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf68e80",
  null
  
)

export default component.exports